<template>
<div class="chapter">
<div class="inner_page">
<p class="ach">Also in </p><p class="acl">THE DEMONATA</p><p class="acl">Series:</p><p class="acl"><em>Lord Loss </em>(Book 1)</p><p class="acl"><em>Demon Thief </em>(Book 2)</p><p class="acl"><em>Slawter </em>(Book 3)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Bec_adca-1.vue?434ebaf4